/**
 * Feature Flags Module (Frontend)
 * 
 * Centralized feature flag checks for gating experimental features.
 * All flags default to false (disabled) when not set.
 * 
 * Note: Frontend flags use VITE_ prefix and import.meta.env
 */

/**
 * Gate I8: Workflow Dashboard feature flag
 * When enabled, exposes the /behavior Workflow tab.
 * Default: false (disabled)
 */
export function isWorkflowDashboardEnabled(): boolean {
  return import.meta.env.VITE_I8_WORKFLOW_DASHBOARD_ENABLED === "true";
}
